<!-- 办公用品采购数据操作 -->
<template>
  <div>
    <div v-if="isLoaded">
      <div class="demo-drawer__content data_action_form">
        <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
          <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
            <template slot="tabs" slot-scope="scope">
              <div class="table_content_box">
                <!-- 主要信息 -->
                <div v-if="scope.index == 0">
                  <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                    <el-row ref="mainForm" v-if="dataActionBox.actionType != 2">
                      <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                        <!-- <df-date v-if="formOneValue.entityField == 'purmSdate'" v-model="sendDataInfo[formOneValue.entityField]"  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" /> -->
                        <!-- 采购日期 -->
                        <el-date-picker v-if="formOneValue.entityField == 'purmSdate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp" style="width: 100%;" :disabled="formOneValue.isChange == 0">
                        </el-date-picker>

                        <!-- 供应商 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'unitName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input clearable  @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'unitId')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.unitName" :maxlength="$store.state.inputLength">
                          <el-button @click="openSearch(formOneValue.searchId, 0, 'unitId')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        </el-tooltip>
                        <!-- 采购员	 -->
                        <el-tooltip v-else-if="formOneValue.entityField == 'opmName'" class="item" :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
        :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                        <el-input clearable  @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'opmId')" :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model="sendDataInfo.opmName" :maxlength="$store.state.inputLength">
                          <el-button @click="openSearch(formOneValue.searchId, 0, 'opmId')" slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        </el-tooltip>

                        <el-input v-else clearable :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>

                      </el-form-item>
                    </el-row>
                    <el-row ref="mainForm" v-if="dataActionBox.actionType == 2">
                      <el-form-item :label="formOneValue.showField+':'" v-if="formOneValue.isShow==1" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                        <span v-if="formOneValue.isRift == 1">
                          <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                        </span>
                        <span v-else-if="formOneValue.entityField == 'purmSdate'">{{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}</span>
                        <span v-else-if="formOneValue.entityField == 'unitId'">{{sendDataInfo.unitName}}</span>
                        <span v-else-if="formOneValue.entityField == 'opmId'">{{sendDataInfo.opmName}}</span>
                        <span v-else-if="formOneValue.entityField == 'depId'">{{sendDataInfo.depName}}</span>
                        <span v-else-if="formOneValue.entityField == 'isWms'">{{sendDataInfo[formOneValue.entityField] == 0? '否' : '新增'}}</span>
                        <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                      </el-form-item>
                    </el-row>
                  </el-form>
                  <!-- 明细信息 -->
                  <div v-if="dataActionBox.actionType != 2">
                    <el-form :inline="true" size="mini">
                      <div v-if="dataActionBox.actionType != 2" id="operateBtn">
                        <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增
                        </el-button>
                        <el-button type="primary" size="mini" @click="deleteDetails()">删除
                        </el-button>
                      </div>
                      <el-table ref="mxTableRef" :data="sendDataInfo.deoauPurchaseDetailAddList" size="mini" :row-class-name="tableRowClassName" @row-dblclick="openDateilsBox" border style="width: 100%" :height="mxHeight">
                        <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                          <template slot-scope="scope">
                            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                              <i class="el-icon-thumb"></i>
                            </el-radio>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                          <template v-if="dataActionBox.actionType != 2" slot-scope="scope">
                            <el-input v-if="formOneValue.entityField == 'osmName'" clearable v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index,formOneValue.entityField, 'osmId,osmName')" :maxlength="$store.state.inputLength">
                              <el-button @click="openSearch(formOneValue.searchId, scope.$index,formOneValue.entityField, 'osmId,osmName')" slot="append" icon="el-icon-search">
                              </el-button>
                            </el-input>
                            <!-- 库房 -->
                            <el-select :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'stName'" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index]['stId']">
                              <el-option v-for="(storageRoomValue,storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                              </el-option>
                            </el-select>
                            <!-- 数量 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(6, scope.$index)" v-else-if="formOneValue.entityField == 'purdNumber'" type="number" min="0" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 单价 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(1, scope.$index)" v-else-if="formOneValue.entityField == 'price'" :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 含税价 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(2, scope.$index)" v-else-if="formOneValue.entityField == 'psprice'" :maxlength="$store.state.inputLength" type="number" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 金额 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(3, scope.$index)" v-else-if="formOneValue.entityField == 'money'" :maxlength="$store.state.inputLength" type="number" v-model.number="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 含税金额 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(4, scope.$index)" v-else-if="formOneValue.entityField == 'psmoney'" :maxlength="$store.state.inputLength" type="number" v-model.number="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 税率 -->
                            <el-input :ref="formOneValue.entityField" @input="calculatePrice(2, scope.$index)" v-else-if="formOneValue.entityField == 'inRate'" :maxlength="$store.state.inputLength" type="number" v-model.number="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>

                            <!-- 备注 -->
                            <el-input :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'remark'" :maxlength="$store.state.inputLength" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]">
                            </el-input>

                            <span v-else>{{sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                  <div v-if="dataActionBox.actionType == 2">
                    <el-form :inline="true" size="mini">
                      <el-table :data="sendDataInfo.deoauPurchaseDetailAddList" :row-class-name="tableRowClassName" @row-dblclick="openDateilsBox" border style="width: 100%" :height="mxHeight">
                        <el-table-column width="180" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1">
                          <template slot-scope="scope">
                            <span v-if="formOneValue.isRift == 1">
                              <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                            </span>
                            <el-select v-else-if="formOneValue.entityField == 'stId'" :disabled="true" v-model="sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]">
                              <el-option v-for="(storageRoomValue,storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                              </el-option>
                            </el-select>
                            <span v-else>{{sendDataInfo.deoauPurchaseDetailAddList[scope.$index][formOneValue.entityField]}}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-form>
                  </div>
                </div>
              </div>
            </template>
          </v-tabs>
        </el-card>
        <div class="foot">
          <div>
            <el-button v-if="dataActionBox.actionType!=2" type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
            <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
          </div>
          <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
            <el-form-item :label="itemV.chineseField" v-for="(itemV,itemK) in footForm" :key="itemK">
              <el-button type="success">{{sendDataInfo[itemV.entityField]}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import SearchScheme from "../byComponents/SearchScheme.vue"

export default {
  name: 'officeSuppliesPurchaseAction',
  props: ['actionData'],
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
  },
  data() {
    //这里存放数据
    return {
      mxHeight: 0,
      dataActionBox: {
        showStatus: false,
        openMode: 'ltr' || 'rtl',
        boxTitle: '新增' || '编辑',
        actionType: 0, // 0新增，1修改
      },
      detaislDataInfo: {},
      selectedDataIndex: 0,
      sendDataInfo: {
        "opmId": '',
        "ormId": '',
        "unitId": '',
        "totalCount": 0,
        "totalMoney": 0,
        "totalNumber": 0,
        purmSdate: 0,
        deoauPurchaseDetailAddList: [],
        "unitName": '',
        "opmName": '',
        "psaiId": '',
      },
      showTabs: '',
      formDataList: [],
      storageRoomList: [],
      editDateilsIndex: "",
      seId: "",
      sField: "",
      seWidth: "",
      seTitle: "",
      seWidth: "",
      DialogVisible: false, //检索
      newFormDataList: [],
      seType: '',
      parentSearchData: {
        unitId: ''
      },
      isLoaded: false,
      tabForm: [],
      mxForm: [],
      footForm: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    'sendDataInfo.deoauPurchaseDetailAddList': {
      handler: function (newValue, oldValue) {
        this.sendDataInfo.totalMoney = 0
        this.sendDataInfo.totalNumber = 0
        this.sendDataInfo.totalCount = 0
        newValue.forEach((item, keys) => {

          if (item.purdNumber < 0) {
            this.sendDataInfo['deoauPurchaseDetailAddList'][keys].purdNumber = 0
            return false;
          }
          if (item.price < 0) {
            this.sendDataInfo['deoauPurchaseDetailAddList'][keys].price = 0
            return false;
          }
          if (item.money < 0) {
            this.sendDataInfo['deoauPurchaseDetailAddList'][keys].money = 0
            return false;
          }
          if (item.psprice < 0) {
            this.sendDataInfo['deoauPurchaseDetailAddList'][keys].psprice = 0
            return false;
          }
          if (item.psmoney < 0) {
            this.sendDataInfo['deoauPurchaseDetailAddList'][keys].psmoney = 0
            return false;
          }

          this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this
            .sendDataInfo.totalMoney, item.psmoney))
          this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this
            .sendDataInfo.totalNumber, item.purdNumber))
        })
        this.sendDataInfo.totalCount = newValue.length
      },
      deep: true,
    }
  },
  //方法集合
  methods: {
    toDetail(orderId) {
      this.$parent.$parent.$parent.toDetail(orderId)
      // this.$emit('toDetail',orderId)
    },


    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      console.log(sId)
      this.seId = sId
      this.seIndex = index
      this.seType = type
      this.sField = sField
      this.DialogVisible = true
      if (type == 'opmId') {
        this.parentSearchData["opmName"] = this.sendDataInfo["opmName"];
      }
      if (type == 'unitId') {
        this.parentSearchData["unitName"] = this.sendDataInfo["unitName"];
      }
    },
    //提取返回
    changeInputModel(val) {
      // console.log(val)
      if (val != "" || val != undefined) {
        if (this.seType == 'unitId') {
          this.sendDataInfo.unitId = val.unitId
          this.sendDataInfo.unitName = val.unitName
        } else if (this.seType == 'opmId') {
          this.sendDataInfo.opmId = val.opmId
          this.sendDataInfo.opmName = val.opmName
        } else if (this.seType == 'osmName') {
          //检测重复
          for (let i = 0; i < this.sendDataInfo.deoauPurchaseDetailAddList.length; i++) {
            const element = this.sendDataInfo.deoauPurchaseDetailAddList[i];
            if (val.osmId == element.osmId) {
              this.$message({
                message: '当前商品已存在，请选择其它商品',
                type: 'error'
              })
              return false
            }
          }
          for (const key in this.sendDataInfo.deoauPurchaseDetailAddList[this.seIndex]) {
            if (val[key]) this.sendDataInfo.deoauPurchaseDetailAddList[this.seIndex][key] = val[key]
          }
        }

        this.DialogVisible = false
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    tableRowClassName({
      row,
      rowIndex
    }) {
      row.index = rowIndex;
    },
    //新增明细
    addDetails(sendDataInfo) {
      var flag = false
      if (this.sendDataInfo.deoauPurchaseDetailAddList.length > 0) {
        this.sendDataInfo.deoauPurchaseDetailAddList.forEach(item => {
          if (item.stId == "") {
            flag = true
            return this.$message({
              message: "请不要重复新增空白行",
              type: "warning",
            });
          }
        })
      }
      if (flag) {
        return
      }
      this.$refs[sendDataInfo].validate((valid) => {
        if (valid) {
          this.sendDataInfo.deoauPurchaseDetailAddList.push(
            JSON.parse(JSON.stringify(this.detaislDataInfo))
          );
          this.$nextTick(() => {
            this.selectedDataIndex = Number(
              this.sendDataInfo.deoauPurchaseDetailAddList.length - 1
            );
            console.log(this.selectedDataIndex);
            this.tableNextFocus("osmName", this.selectedDataIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.deoauPurchaseDetailAddList[this.selectedDataIndex]
            );
          });
        } else {
          return this.$message({
            message: "请完善必填信息",
            type: "warning",
          });
        }
      });
    },
    tableNextFocus(field, index) {
      this.seIndex = index;
      if (field == "keydown") {
        if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
          this.$refs["osmName"][index + 1].focus();
          this.selectedDataIndex = index + 1;
          this.$nextTick(() => {
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
              this.sendDataInfo.woApplyDetails[this.selectedDataIndex]
            );
          });
          return;
        }
        this.addDetails("sendDataInfo");
        return;
      }
      this.$refs[field][index].focus();
    },
    openDateilsBox(row, column, event) {
      let flag = false
      this.$refs['sendDataInfo'].validate((valid) => {
        if (valid) {
          if (row) {
            this.editDateilsIndex = row.index
            this.detaislDataInfo = JSON.parse(JSON.stringify(row))
          } 
        } else {
          this.$message({
            message: '请完善必填信息',
            type: 'error'
          })
          flag = true
          return false;
        }
      })

      // if(flag) return false

    },
    detailsAction(cate = 0) {
      if (cate == 0) {
        this.editDateilsIndex = ""
        return false
      }

      var dataInfo = JSON.parse(JSON.stringify(this.detaislDataInfo))
      if (dataInfo.purdNumber <= 0) {
        this.$message({
          message: '请填写采购数量',
          type: 'error'
        });
        return false
      }
      if (this.editDateilsIndex !== "") {
        this.sendDataInfo.deoauPurchaseDetailAddList.splice(this.editDateilsIndex, 1)
      }
      this.sendDataInfo.deoauPurchaseDetailAddList.push(dataInfo)
      this.editDateilsIndex = ""
    },
    // 计算价格
    calculatePrice(cate, index) {
      var info = this.sendDataInfo.deoauPurchaseDetailAddList[index]
      // if (info.purdNumber <= 0) {
      //     this.$message({
      //         message: '请先填写采购数量',
      //         type: 'error'
      //     });
      //     return false
      // }
      switch (cate) {
        case 1: // 单价计算
          // 计算含税价格 单价+单价*税率/100
          var thisPrice = NP.plus(info.price, NP.divide(NP.times(info.price, info.inRate), 100))
          // this.detaislDataInfo.psprice  =  this.$common.getDecimalInfo(2,thisPrice)
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psprice = this.$common.getDecimalInfo(2,
            thisPrice)
          // 计算金额 单价*数量
          // this.detaislDataInfo.money  =  this.$common.getDecimalInfo(3,NP.times(info.price,info.purdNumber))
          this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3, NP
            .times(info.price, info.purdNumber))
          // 计算含税金额 含税价格*数量
          // this.detaislDataInfo.psmoney  =   this.$common.getDecimalInfo(3,NP.times(thisPrice,info.purdNumber))
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3, NP
            .times(thisPrice, info.purdNumber))
          break;
        case 2: // 含税价格计算
          // 计算单价 含税价格/(税率/100+1)
          var thisPrice = NP.divide(info.psprice, NP.plus(NP.divide(info.inRate, 100), 1))
          this.sendDataInfo.deoauPurchaseDetailAddList[index].price = this.$common.getDecimalInfo(2,
            thisPrice)
          // 计算金额 单价*数量
          this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3, NP
            .times(thisPrice, info.purdNumber))
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3, NP
            .times(info.psprice, info.purdNumber))
          break;
        case 3: // 通过总金额计算
          // 计算单价  总金额 / 数量
          var thisPrice = NP.divide(info.money, info.purdNumber)
          this.sendDataInfo.deoauPurchaseDetailAddList[index].price = this.$common.getDecimalInfo(2,
            thisPrice)
          // 计算含税价格 单价+单价*税率/100
          var thisPriceTwo = NP.plus(thisPrice, NP.divide(NP.times(thisPrice, info.inRate), 100))
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psprice = this.$common.getDecimalInfo(3,
            thisPriceTwo)
          // 计算含税金额 含税价格*数量
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3, NP
            .times(thisPriceTwo, info.purdNumber))
          break;
        case 4: // 通过含税金额计算
          // 计算含税价格  含税金额 / 数量
          var thisPrice = NP.divide(info.psmoney, info.purdNumber)
          this.sendDataInfo.deoauPurchaseDetailAddList[index].psprice = this.$common.getDecimalInfo(2,
            thisPrice)
          // 计算单价 含税价格/(税率/100+1)
          var thisPriceTwo = NP.divide(thisPrice, NP.plus(NP.divide(info.inRate, 100), 1))
          this.sendDataInfo.deoauPurchaseDetailAddList[index].price = this.$common.getDecimalInfo(2,
            thisPriceTwo)
          // 计算总金额 单价*数量
          this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3, NP
            .times(thisPriceTwo, info.purdNumber))
          break;
        default: // 通过数量计算
          // // 计算金额 单价*数量
          // this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3, NP.times(info.price, info.purdNumber))
          // // 计算含税金额 含税价格*数量
          // this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3, NP.times(info.psprice, info.purdNumber))
          if (info.price > 0) {
            // 计算含税价格 单价+单价*税率/100
            var thisPrice = NP.plus(info.price, NP.divide(NP.times(info.price, info.inRate), 100))
            // this.detaislDataInfo.psprice  =  this.$common.getDecimalInfo(2,thisPrice)
            this.sendDataInfo.deoauPurchaseDetailAddList[index].psprice = this.$common.getDecimalInfo(2,
              thisPrice)
            // 计算金额 单价*数量
            // this.detaislDataInfo.money  =  this.$common.getDecimalInfo(3,NP.times(info.price,info.purdNumber))
            this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3,
              NP.times(info.price, info.purdNumber))
            // 计算含税金额 含税价格*数量
            // this.detaislDataInfo.psmoney  =   this.$common.getDecimalInfo(3,NP.times(thisPrice,info.purdNumber))
            this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3,
              NP.times(thisPrice, info.purdNumber))
          } else if (info.psprice) {
            // 计算单价 含税价格/(税率/100+1)
            var thisPrice = NP.divide(info.psprice, NP.plus(NP.divide(info.inRate, 100), 1))
            this.sendDataInfo.deoauPurchaseDetailAddList[index].price = this.$common.getDecimalInfo(2,
              thisPrice)
            // 计算金额 单价*数量
            this.sendDataInfo.deoauPurchaseDetailAddList[index].money = this.$common.getDecimalInfo(3,
              NP.times(thisPrice, info.purdNumber))
            // 计算含税金额 含税价格*数量
            this.sendDataInfo.deoauPurchaseDetailAddList[index].psmoney = this.$common.getDecimalInfo(3,
              NP.times(info.psprice, info.purdNumber))
          }
          break;
      }
    },
    initActionBox(sendDataInfo) {
      var cancelTitle = this.dataActionBox.actionType == 0 ? '新增' : '修改'
      this.$confirm('确定取消' + cancelTitle + '吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('drawerCancel')
        // this.$parent.getDataList()
        this.init()
        this.$refs[sendDataInfo].resetFields();
      }).catch(() => { });
    },
    init() {
      for (let key in this.sendDataInfo) {
        if (key == 'pisOrderAuxinf') {
          for (let sonOne in this.sendDataInfo[key]) {
            this.sendDataInfo[key][sonOne] = ''
          }
        } else {
          this.sendDataInfo[key] = ''
        }
      }
      this.sendDataInfo.purmSdate = this.$moment().valueOf()
      this.sendDataInfo.deoauPurchaseDetailAddList = []
      this.sendDataInfo.totalMoney = 0
      this.sendDataInfo.totalNumber = 0
      this.sendDataInfo.totalCount = 0
    },

    // 选择采购员
    // selectUserOne(data) {
    //     data.forEach(item => {
    //         if (item.opmId == this.sendDataInfo.opmId) {
    //             this.sendDataInfo.psomBusdept = item.depId
    //         }
    //     })
    // },

    openBox(cate, formData, oldData = '') {
      this.showTabs = formData[0].jciName
      this.formDataList = formData
      this.filterMainField()
      this.init()
      if (cate == 0) {
        this.dataActionBox.boxTitle = '新增信息'
        this.dataActionBox.openMode = 'ltr'
        this.parentSearchData.unitId = ''
      } else if (cate == 1) {
        this.dataActionBox.boxTitle = '编辑信息'
        this.dataActionBox.openMode = 'rtl'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
        for (let key in dataInfo) {
          this.sendDataInfo[key] = dataInfo[key]
          if (key == 'detailList') {
            this.sendDataInfo.deoauPurchaseDetailAddList = dataInfo[key]
          }
        }
      } else {
          this.dataActionBox.boxTitle = '查看信息'
        var dataInfo = JSON.parse(JSON.stringify(oldData))
            console.log(this.sendDataInfo, oldData);
        for (let key in dataInfo) {
            this.sendDataInfo[key] = dataInfo[key]
          if (key == 'detailList') {
              this.sendDataInfo.deoauPurchaseDetailAddList = dataInfo[key]
          }
        }
      }
      this.dataActionBox.actionType = cate
      this.dataActionBox.showStatus = true
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.dataActionBox.actionType != 2) {
            this.mxHeight = this.$common.getBtnHeight()
          } else {
            this.mxHeight = this.$common.getHeight()
          }
        }, 16.7)
      })
    },
    //确认新增
    sendDataAction(formName1) {
      this.$refs[formName1].validate((valid) => {
        if (valid) {
          this.sub()
        } else {
          this.$message({
            message: '请完善必填信息',
            type: 'error'
          })
          return false;
        }
      })
    },
    async sub() {
      if (this.sendDataInfo.deoauPurchaseDetailAddList.length < 1) {
        this.$message({
          message: '请添加采购订单明细',
          type: 'error'
        });
        return;

      } else if (this.sendDataInfo.deoauPurchaseDetailAddList.some((val) => val.osmId == '' || val
        .purdNumber == '' || val.purdNumber <= 0 || val.psmoney <= 0)) {
        this.$message({
          type: "error",
          message: "明细商品采购数量含税金额等不能为0或者空",
        });
        return;
      }
      var responseData
      if (this.dataActionBox.actionType == 0) {
        responseData = await this.$http.purchaseAdd(this.sendDataInfo)
      } else {
        responseData = await this.$http.purchaseUpdate(this.sendDataInfo)
      }
      if (responseData.status == 200) {
        this.init()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.$emit('drawerCancel')
        // this.dataActionBox.showStatus = false
        // this.$parent.getDataList()

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    deleteDetails() {
      if (this.sendDataInfo.deoauPurchaseDetailAddList.length < 1) {
        return this.$message({
          message: '暂无可删除明细',
          type: 'warning'
        })
        return false
      }
      this.sendDataInfo.deoauPurchaseDetailAddList.splice(this.selectedDataIndex, 1)
      this.selectedDataIndex = 0
    },

    // 获取所有可用库房列表
    async getAllStorageRoom() {
      let responseData = await this.$http.getAllStorageRoom()
      if (responseData.status == 200) {
        this.storageRoomList = responseData.result
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    //换行提示
    lineMessageBox(data) {
      let txtArr = data.message.split('<br/>')
      let newArr = []
      const h = this.$createElement
      for (const i in txtArr) {
        newArr.push(h('p', null, txtArr[i]))
      }
      this.$alert(h('div', null, newArr), '提示', {
        confirmButtonText: '确定',
        callback: action => { }
      })
    },
    // 过滤表单不同类型
    filterMainField() {
      var mainFormList = []
      this.formDataList.forEach(item => {
        if (item.jciType == 1) {
          mainFormList.push(item)
        } else if (item.jciType == 2) {
          this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
          this.mxForm.forEach(item1 => {
            if (item1.fieldType == 'number') {
              this.$set(this.detaislDataInfo, item1.entityField, 0)
            } else if (item1.fieldType == 'search' && item1.setField) {
              var arr = item1.setField.split(',')
              arr.forEach(item2 => {
                this.$set(this.detaislDataInfo, item2, "")
              })
            } else {
              this.$set(this.detaislDataInfo, item1.entityField, "")
            }
          })
        } else if (item.jciType == 3) {
          this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
        }
      })
      mainFormList.forEach((key, i) => {
        this.tabForm[i] = JSON.parse(JSON.stringify(key))
        this.tabForm[i].jurconfigform = []
        for (let index = 0; index < key.jurconfigform.length; index++) {
          if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key
            .jurconfigform[index])
        }
      })
      var arr = [{ entityField: "deoauPurchaseDetailAddList" }]
      var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
      for (let key in obj) {
        this.$set(this.sendDataInfo, key, obj[key])
      }
      this.$set(this.sendDataInfo, "purmSdate", this.$moment().valueOf())
    }



  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$nextTick(() => {
      var params = this.actionData
      this.openBox(params.cate, params.formData, params.oldData)
      this.isLoaded = true
    })
    this.getAllStorageRoom()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_button_box {
  height: 200px;
  background-color: red;
}

.table_content_box {
  overflow-y: auto;
}

.el-row {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.el-drawer {
  outline: none;
}

.v-modal {
  position: static !important;
  width: 100%;
  height: 100%;
  background: transparent;
}
</style>